<questionnaire-svg-sprite />
<och-popup-modal [showCloseButton]="false" [title]="title" #modal>
<ng-container *ngIf="!questionnaireCompleted; else finishedTemplated">
    <div class="questionnaire-container">

      <!-- Preload the image -->
      <img [src]="finishedOwlMascot" style="display: none"/>

        <div class="question-container">

            <ul *ngFor="let question of questions; index as i">

                <h4>
                    <span class="svg-icon">
                    <svg *ngIf="!answers[question.id]" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <use xlink:href="#questionnaireStarIcon"></use>
                    </svg>
                    <span class="svg-icon-number">{{i + 1}}</span>
                    </span>


                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" *ngIf="answers[question.id]">
                        <use xlink:href="#greenCheckedStarIcon"></use>
                    </svg>

                    <div class="question-text">
                        <span>{{question.text}}</span>
                        <label class="subText" *ngIf="question?.subText">{{question?.subText}}</label>
                    </div>
                </h4>

                <ol *ngIf="question?.type === 'radio' && visibility[question.id]">
                    <ng-container *ngFor="let option of question.options">
                        <li (click)="selectOption(question, option)">
                            {{option.label}}
                        </li>
                    </ng-container>
                </ol>

                <ol *ngIf="question?.type === 'dropdown' && (visibility[question.id] || answers?.[question.id])">
                    <mat-form-field [key]="question.id" *ngIf="question?.type === 'dropdown'" class="language-field" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{question?.placeholder || "Choose an option"}}</mat-label>
                        <mat-select [disabled]="answers?.[question.id] ? true : false" class="language-dropdown"  (selectionChange)="onSelectionChange($event, question)">

                        <mat-option *ngFor="let option of question?.options" [value]="option">
                            <div class="dropdown-option-value">
                            {{option.label}}
                            </div>
                        </mat-option>

                        <!-- <mat-select-trigger>
                            <div class="selected-language-value">
\                                {{answers?.[question.id]}}
                            </div>
                        </mat-select-trigger> -->

                        </mat-select>

                    </mat-form-field>
                </ol>
                <ol  *ngIf="finishBtnVisible && i === (questions?.length - 1)" >

                    <button [disabled]="!isFormValid()" class="questionnaire-btn finish-btn" (click)="finish()">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_11_188)">
                            <path d="M1.44189 5.19039L3.46036 7.20885L8.074 2.59521" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_11_188">
                            <rect width="9.22727" height="9.22727" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>

                        <span>
                            Finish
                        </span>
                    </button>

                </ol>

            </ul>

        </div>

        <!-- <>Logo here</> -->
        <div class="logo">
            <img [src]="mascotOwlUrl" />
            <div class="logo-text-container">
            <h6>Why are we asking this?</h6>

            <div class="logo-text">
                <span>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_18_5076)">
                        <path d="M5 1.5625V8.4375" stroke="#909AAA" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1.875 3.125L8.125 6.875" stroke="#909AAA" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1.875 6.875L8.125 3.125" stroke="#909AAA" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_18_5076">
                        <rect width="10" height="10" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>

                </span>
                <p>Your answers will help us provide you with more relevant guidance and content.</p>
            </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #finishedTemplated>
    <div class="questionnaire-finished-container">
        <div class="questionnaire-finished-img-container">
            <img [src]="finishedOwlMascot" />
        </div>

        <div class="finished-text">

            <h4>You've made it!</h4>
            <p>Great! Your online school has been created. Time to start building your school site and create your courses.</p>
            <button class="questionnaire-btn" (click)="done()"><span>Build Your School</span></button>

        </div>
    </div>
</ng-template>
</och-popup-modal>
